import { render, staticRenderFns } from "./RecipeBatchList.vue?vue&type=template&id=728942f6&"
import script from "./RecipeBatchList.vue?vue&type=script&lang=js&"
export * from "./RecipeBatchList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports